if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
      }
      this.mql = window.matchMedia('(min-width: 750px)');
      this.desktopArrowMql = window.matchMedia('(min-width: 990px)');
      if (!this.elements.viewer) return;

      this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
      this.initDesktopGalleryArrows();
      this.initGalleryDots();
      if (this.elements.thumbnails) {
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch.querySelector('button').addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      this.initMediaObserver();
      this.initThumbnailVideos();

      const activeMedia = this.elements.viewer.querySelector('.is-active[data-media-id]') || this.elements.viewer.querySelector('[data-media-id]');
      if (activeMedia) window.setTimeout(() => {
        this.playActiveMedia(activeMedia);
        this.updateGalleryArrowState(activeMedia);
        this.updateGalleryDotState(activeMedia);
      }, 0);
    }

    onSlideChanged(event) {
      const currentElement = event.detail && event.detail.currentElement;
      if (!currentElement || !currentElement.dataset || !currentElement.dataset.mediaId) return;

      this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.toggle('is-active', element === currentElement);
      });
      this.playActiveMedia(currentElement);
      this.updateGalleryArrowState(currentElement);
      this.updateGalleryDotState(currentElement);

      if (!this.elements.thumbnails) return;
      const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${ currentElement.dataset.mediaId }"]`);
      this.setActiveThumbnail(thumbnail);
    }

    setActiveMedia(mediaId, prepend) {
      const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${ mediaId }"]`);
      this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });
      activeMedia.classList.add('is-active');

      if (prepend) {
        activeMedia.parentElement.prepend(activeMedia);
        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
          activeThumbnail.parentElement.prepend(activeThumbnail);
        }
        if (this.elements.viewer.slider) this.elements.viewer.resetPages();
      }

      this.preventStickyHeader();
      window.setTimeout(() => {
        if (this.elements.thumbnails) {
          activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
        }
        if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
          activeMedia.scrollIntoView({behavior: 'smooth'});
        }
      });
      this.playActiveMedia(activeMedia);
      this.updateGalleryArrowState(activeMedia);
      this.updateGalleryDotState(activeMedia);

      if (!this.elements.thumbnails) return;
      const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
      this.setActiveThumbnail(activeThumbnail);
      this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
    }

    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;

      this.elements.thumbnails.querySelectorAll('button').forEach((element) => element.removeAttribute('aria-current'));
      thumbnail.querySelector('button').setAttribute('aria-current', true);
      if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

      this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
    }

    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image) return;
      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', false);
        this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
          '[index]',
          position
        );
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
      };
      image.src = image.src;
    }

    playActiveMedia(activeItem) {
      window.pauseAllMedia();
      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia) deferredMedia.loadContent(false);
      this.autoplayMediaItem(activeItem);
      this.autoplayPeekMedia(activeItem);
    }

    autoplayMediaItem(mediaItem) {
      if (!mediaItem) return;

      window.setTimeout(() => {
        const video = mediaItem.querySelector('video');
        if (video) {
          video.muted = true;
          video.defaultMuted = true;
          video.playsInline = true;
          video.setAttribute('muted', '');
          video.setAttribute('playsinline', '');
          video.setAttribute('autoplay', '');
          const playPromise = video.play();
          if (playPromise && typeof playPromise.catch === 'function') playPromise.catch(() => {});
        }

        const iframe = mediaItem.querySelector('iframe');
        if (!iframe) return;

        const src = iframe.getAttribute('src');
        if (src) {
          const url = new URL(src, window.location.origin);
          const params = url.searchParams;
          let shouldUpdate = false;

          if (iframe.classList.contains('js-youtube')) {
            [['autoplay', '1'], ['mute', '1'], ['playsinline', '1'], ['enablejsapi', '1']].forEach(([key, value]) => {
              if (params.get(key) !== value) {
                params.set(key, value);
                shouldUpdate = true;
              }
            });
          }

          if (iframe.classList.contains('js-vimeo')) {
            [['autoplay', '1'], ['muted', '1'], ['autopause', '0']].forEach(([key, value]) => {
              if (params.get(key) !== value) {
                params.set(key, value);
                shouldUpdate = true;
              }
            });
          }

          if (shouldUpdate) iframe.src = url.toString();
        }

        if (iframe.classList.contains('js-youtube') && iframe.contentWindow) {
          iframe.contentWindow.postMessage('{"event":"command","func":"mute","args":""}', '*');
          iframe.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
        }

        if (iframe.classList.contains('js-vimeo') && iframe.contentWindow) {
          iframe.contentWindow.postMessage('{"method":"setVolume","value":0}', '*');
          iframe.contentWindow.postMessage('{"method":"play"}', '*');
        }
      }, 50);
    }

    autoplayPeekMedia(activeItem) {
      if (this.mql.matches || !activeItem) return;

      const mediaItems = Array.from(this.elements.viewer.querySelectorAll('.product__media-item[data-media-id]'));
      const activeIndex = mediaItems.indexOf(activeItem);
      if (activeIndex < 0) return;

      const nextItem = mediaItems[activeIndex + 1];
      if (!nextItem) return;

      const nextVideo = nextItem.querySelector('video, iframe');
      if (!nextVideo) return;

      const viewerRect = this.elements.viewer.getBoundingClientRect();
      const nextRect = nextItem.getBoundingClientRect();
      const isPeeking = nextRect.left < viewerRect.right && nextRect.right > viewerRect.right;
      if (!isPeeking) return;

      const deferredMedia = nextItem.querySelector('.deferred-media');
      if (deferredMedia) deferredMedia.loadContent(false);
      this.autoplayMediaItem(nextItem);
    }

    initMediaObserver() {
      if (!('IntersectionObserver' in window)) return;

      this.mediaObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          this.playActiveMedia(entry.target);
        });
      }, {
        threshold: 0.6
      });

      this.elements.viewer.querySelectorAll('[data-media-id]').forEach((mediaItem) => {
        if (!mediaItem.querySelector('.deferred-media, video, iframe')) return;
        this.mediaObserver.observe(mediaItem);
      });
    }

    initThumbnailVideos() {
      if (!this.elements.thumbnails || !window.matchMedia('(min-width: 990px)').matches) return;

      const playThumbnailVideo = (video) => {
        video.muted = true;
        video.defaultMuted = true;
        video.playsInline = true;
        video.setAttribute('muted', '');
        video.setAttribute('playsinline', '');
        video.setAttribute('autoplay', '');
        const playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') playPromise.catch(() => {});
      };

      this.elements.thumbnails.querySelectorAll('.thumbnail__video').forEach((video) => {
        playThumbnailVideo(video);
        video.addEventListener('loadeddata', () => playThumbnailVideo(video), { once: true });
      });
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
    }

    initDesktopGalleryArrows() {
      this.galleryControls = this.elements.viewer.querySelector('.slider-buttons');
      if (!this.galleryControls) return;

      this.galleryPrevButton = this.galleryControls.querySelector('.slider-button--prev');
      this.galleryNextButton = this.galleryControls.querySelector('.slider-button--next');
      if (!this.galleryPrevButton || !this.galleryNextButton) return;

      this.galleryPrevButton.addEventListener('click', this.onDesktopArrowClick.bind(this, -1), true);
      this.galleryNextButton.addEventListener('click', this.onDesktopArrowClick.bind(this, 1), true);
    }

    initGalleryDots() {
      this.galleryDotButtons = Array.from(this.elements.viewer.querySelectorAll('.slider-counter__link--dots[data-target]'));
      if (!this.galleryDotButtons.length) return;

      this.galleryDotButtons.forEach((dotButton) => {
        dotButton.addEventListener('click', (event) => {
          event.preventDefault();
          this.setActiveMedia(dotButton.dataset.target, false);
        });
      });
    }

    onDesktopArrowClick(step, event) {
      if (!this.desktopArrowMql.matches) return;

      const mediaItems = Array.from(this.elements.viewer.querySelectorAll('.product__media-item[data-media-id]'));
      if (mediaItems.length <= 1) return;

      const activeItem = this.elements.viewer.querySelector('.product__media-item.is-active[data-media-id]') || mediaItems[0];
      const activeIndex = mediaItems.indexOf(activeItem);
      const nextIndex = Math.min(Math.max(activeIndex + step, 0), mediaItems.length - 1);
      if (nextIndex === activeIndex) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();
      this.setActiveMedia(mediaItems[nextIndex].dataset.mediaId, false);
    }

    updateGalleryArrowState(activeItem) {
      const controls = this.elements.viewer.querySelector('.slider-buttons');
      if (!controls) return;

      const prevButton = controls.querySelector('.slider-button--prev');
      const nextButton = controls.querySelector('.slider-button--next');
      if (!prevButton || !nextButton) return;

      const mediaItems = Array.from(this.elements.viewer.querySelectorAll('.product__media-item[data-media-id]'));
      if (!mediaItems.length) return;

      const activeIndex = Math.max(mediaItems.indexOf(activeItem), 0);
      const isFirstMedia = activeIndex === 0;
      const isLastMedia = activeIndex === mediaItems.length - 1;

      prevButton.toggleAttribute('disabled', isFirstMedia);
      nextButton.toggleAttribute('disabled', isLastMedia);
    }

    updateGalleryDotState(activeItem) {
      if (!this.galleryDotButtons || !this.galleryDotButtons.length || !activeItem) return;

      this.galleryDotButtons.forEach((dotButton) => {
        const isActive = dotButton.dataset.target === activeItem.dataset.mediaId;
        dotButton.classList.toggle('slider-counter__link--active', isActive);
        if (isActive) {
          dotButton.setAttribute('aria-current', true);
        } else {
          dotButton.removeAttribute('aria-current');
        }
      });
    }
  });
}
